export const HUBSPOT_IMPORT_RETURN_TO = 'settings-import';
export const HUBSPOT_IMPORT_INTENT = 'import';
